import app from "@/main";
import TakipDosya from "../../../uyap/classes/TakipDosya";
import {ITarafBilgisiDetayli} from "../../../uyap/GetDosyaTarafBilgileri";
import {IcraPesinHarcGetirCevap} from "../../../uyap/IcraPesinHarcGetir";
import {OdemeTipiEnum} from "../../../takip_ac/OdemeTipleri";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";
import {TarafRol} from "../../../enum/uyap/TarafRol";

export class HarcMasrafOdeCevap {
    dosyaNo: string = "";
    // Odemenin gercekten yapildigi dosya. Talepteki degerin kopyasi DEGILDIR; yanlis dosyada
    // islem yapilirsa kaydin uzerinden tespit edilebilmesi icin tutulur. (DEV-2643)
    // Kalici kimlik ikilisi birimAdi + dosyaNo'dur; dosyaId sadece odeme anindaki degerdir,
    // UYAP dosyaId'leri sifreli ve surekli degistigi icin sonradan cozumlenemeyebilir.
    birimAdi: string = "";
    dosyaId: string = "";
    taraf: string = "";
    pesinHarcTutari: number = 0;
    pesinHarcDusulduMu: "Evet" | "Hayır" = "Hayır";
    tutar: any = "";
    toplamTutar: any = "";
    message: string = "";
}

/**
 * UYAP portalinin dosya_odeme_islemleri_brd.ajx istegine gonderdigi pul satiriyla
 * birebir ayni sekil. Alanlarin tamami string, tutar 2 haneli ondalikli ("164.00").
 */
interface PostaMasraflari {
    silId: number,
    id: string,
    tur: "D",
    adi: string,
    adet: string,
    tutar: string,
    aciklama: string
}

export interface HarcMasrafOdeTaskInterface {
    id: number,
    tur: string,
    adi: string,
    adet: number,
    tutar: number,
    toplamTutar: number,
    tarafRolId: number,
    tarafRolAdi: string | undefined,
    pesinHarcDusulsunMu: boolean,
    // Harc turu pesin harc dusmeye musait mi (oran bazli harclarda true)
    pesinHarcDusulebilirMi: boolean,
    pesinHarcTutari: number,
    tarafBilgileri: any,
    tahsilatAciklama: string,
    tahsilatHarcOrani: number | null,
    otomatikIliskilendirme: boolean,
    tahsilatKayitId: number | null,
}

export class HarcMasrafOdeTaskHandler extends AbstractTaskHandler {

    //TODO daha önce ödenmişmi Dosya filtreleme yapilmali dosyalar taska gonderilirken dosya esasnoya gore filtrelensin ** Emre
    //@ts-ignore
    dosya: TakipDosya = {};
    data: Array<HarcMasrafOdeTaskInterface> = [];
    //@ts-ignore
    firstData: HarcMasrafOdeTaskInterface = {};
    harcMasraflar: Array<any> = [];
    response: HarcMasrafOdeCevap = new HarcMasrafOdeCevap();

    async handle(task: ITask): Promise<ITask> {
        try {
            // DosyaBul, AvukatIcraDosyalari cevabindaki dosyayi doner; birimTuru3 dahil
            // tum birim alanlari dolu gelir.
            let dosya = await app.$uyap.DosyaBul().run(task, true);
            this.dosya = TakipDosya.fromJson(dosya);
            this.data = task.data;
            this.firstData = this.data[0];
            // Talepteki degil, DosyaBul'un cozdugu dosyanin bilgileri kaydedilir. (DEV-2643)
            this.response.dosyaNo = this.dosya.dosyaNo || task.dosya_esas_no;
            this.response.birimAdi = this.dosya.birimAdi || task.birim_adi;
            this.response.dosyaId = this.dosya.dosyaId;
            await this.dosya.dosyaDetayliTarafBilgileriQuery();
            // Pul odemesinde UYAP taraf bilgisi istemiyor (tarafDVO "null"), bu yuzden
            // coklu taraf kontrolu yalnizca harc/tahsilat icin gecerli.
            let sadecePulOdemesi = this.data.every(harcMasraf => harcMasraf.tur == "D");
            if (!sadecePulOdemesi) {
                let tarafRolId = this.firstData.tarafRolId;
                let ayniTurTaraflar = this.dosya.detayliTarafBilgileri.filter((taraf: ITarafBilgisiDetayli) => taraf.dosyaKisiDVO.tarafRolu == tarafRolId);
                if (ayniTurTaraflar.length > 1) {
                    throw new Error('Dosyada aynı taraf türünden birden fazla bulunduğu için ödeme iptal edildi.Lütfen bu dosya için ödeme işlemlerinizi UYAP üzerinden yapınız.');
                }
            }
            await this.harcMasrafHazirla();
            if (this.harcMasraflar.length == 0)
                throw new Error("Dosyada Taraf Bulunamadı");

            console.log("harcmasraflar", this.harcMasraflar);
            //this.postaMasraflari = this.harcMasraflar.filter(x=>x.tur == HarcMasrafTypeEnum.PUL);
            let odemeBilgileri = await this.odemeBilgileriOlustur();
            // Pul odemesinde UYAP harcMasrafTipi'ni bos gonderir, tur bilgisi
            // postaMasraflariList satirinin icinde tasinir. "D" gonderilirse UYAP
            // harcMasrafList parse dalina girip hata donuyor.
            let harcMasrafTipi = odemeBilgileri.postaMasraflariList.length > 0 ? "" : this.firstData.tur;

            let requestObject = {
                dosyaId: this.dosya.dosyaId,
                // UYAP bu iki alanda JSON null degil "null" metni bekliyor
                tarafDVO: "null",
                harcMasrafTipi: harcMasrafTipi,
                harcMasrafList: odemeBilgileri.harcMasrafList,
                postaMasraflariList: odemeBilgileri.postaMasraflariList,
                // Urun karari: sadece e-barobirlik kart destekleniyor, Vakifbank bilerek eklenmedi.
                odemeTipi: OdemeTipiEnum.Ebarobirlikkart,
                uyapId: null,
                vakifbankHesapBilgileri: "null",
            }
            console.log(requestObject);
            //@ts-ignore
            let dosyaOdemeResult = await app.$uyap.DosyaOdemeIslemleri().run(requestObject);
            //let dosyaOdemeResult = {message:"sadsadsa"};
            this.response.message = dosyaOdemeResult.message;
            task.response = this.response;
            task.status = TaskDurum.BITTI_BASARILI
            return task;
        } catch (error) {
            console.log("CATCH", error);
            this.response.message = error.message || "Bilinmeyen bir hata oluştu";
            task.response = this.response;
            task.status = TaskDurum.BITTI_HATALI;
            throw new Error(error.message);
        }
    }

    async harcMasrafHazirla() {
        let pesinHarc: IcraPesinHarcGetirCevap | null = null;
        try {
            pesinHarc = await app.$uyap.IcraPesinHarcGetir().run({dosyaId: this.dosya.dosyaId});
        } catch (e) {
            console.error(e)
        }
        if (pesinHarc)
            this.response.pesinHarcTutari = pesinHarc.dusulenPesinHarc;

        let pesinHarcDusuldu = false;
        let toplamTutar = 0;
        let normalTutar = 0;
        this.data.forEach((harcMasraf: any) => {
            let taraf = this.dosya.detayliTarafBilgileri.find((taraf: ITarafBilgisiDetayli) => taraf.dosyaKisiDVO.tarafRolu == harcMasraf.tarafRolId);
            if (harcMasraf.tahsilatAciklama == null || harcMasraf.tahsilatAciklama == "")
                harcMasraf.tahsilatAciklama = "-";
            if (taraf) {
                let harcMasrafData: any = Object.assign({}, harcMasraf);
                harcMasrafData.tarafBilgileri = {};
                if (taraf.dosyaKisiDVO.kisiMiKurumMu == 0)
                    harcMasrafData.tarafBilgileri.adSoyad = taraf.dosyaKisiDVO.kisiBilgDVO.adi + " " + taraf.dosyaKisiDVO.kisiBilgDVO.soyadi;
                else
                    harcMasrafData.tarafBilgileri.adSoyad = taraf.dosyaKisiDVO.kurumBilgDVO.kurumAdi;

                this.response.taraf = harcMasrafData.tarafBilgileri.adSoyad;
                harcMasrafData.tarafBilgileri.tarafDosyaKisiId = taraf.dosyaKisiDVO.dosyaKisiId;
                harcMasrafData.tarafBilgileri.kisiKurumId = taraf.dosyaKisiDVO.ilkKisiKurumId;
                harcMasrafData.tarafBilgileri.rolId = taraf.dosyaKisiDVO.tarafRolu;

                // HarcMasrafOdeTaskInterface'e göre eksik alanları tamamla
                harcMasrafData.toplamTutar = harcMasrafData.tutar * harcMasrafData.adet;
                harcMasrafData.tarafRolAdi = TarafRol[taraf.dosyaKisiDVO.tarafRolu] || undefined;
                // UYAP, pesin harc dusmeye musait (oran bazli) harclarda kutucuk isaretli
                // olmasa bile dosyanin pesin harc tutarini bu alanda gonderiyor; dusme
                // yapilip yapilmayacagini pesinHarcDusulsunMu belirliyor.
                harcMasrafData.pesinHarcTutari = harcMasrafData.pesinHarcDusulebilirMi ? this.response.pesinHarcTutari : 0;

                // Tahsilat harc orani/kayitId kullanicinin wizard'da sectigi degerdir; kayitId
                // canli UYAP'tan (TahsilHarcOranlariniGetir) gelir ve dosyaya ozeldir, burada
                // yeniden turetilemez. Sadece bos gelme ihtimaline karsi varsayilan atiyoruz.
                harcMasrafData.tahsilatHarcOrani = harcMasrafData.tahsilatHarcOrani || 0;
                harcMasrafData.tahsilatKayitId = harcMasrafData.tahsilatKayitId || 0;
                harcMasrafData.otomatikIliskilendirme = harcMasrafData.otomatikIliskilendirme || false;

                // UYAP harcMasrafList'te satir basina "adet x birim tutar" bekliyor.
                let satirTutari = parseFloat(harcMasrafData.tutar) * parseFloat(harcMasrafData.adet);
                normalTutar = normalTutar + satirTutari;
                if (harcMasrafData.pesinHarcDusulsunMu === true && pesinHarcDusuldu === false) {
                    if (this.response.pesinHarcTutari > 0) {
                        // Pesin harc dosya basina tek seferlik dusulur, adet ile carpilmaz.
                        satirTutari = satirTutari - this.response.pesinHarcTutari;
                        pesinHarcDusuldu = true;
                        this.response.pesinHarcDusulduMu = "Evet";
                    }
                }
                harcMasrafData.odenecekTutar = parseFloat(satirTutari.toFixed(2));
                toplamTutar = toplamTutar + harcMasrafData.odenecekTutar; // harc dusulmus tutar
                this.harcMasraflar.push(harcMasrafData);
                console.log("1. Harc masraf !!!!", harcMasrafData);
            } else {
                throw new Error("Dosyada Taraf Bulunamadı");
            }
            console.log("Harc masraf !!!!", this.harcMasraflar);
        });
        this.response.tutar = normalTutar.toString();
        this.response.toplamTutar = toplamTutar.toString();
    }

    odemeBilgileriOlustur(): Promise<{ harcMasrafList: string, postaMasraflariList: Array<PostaMasraflari> }> {
        try {
            let harcMasrafSatirlari: Array<string> = [];
            let postaMasraflariList: Array<PostaMasraflari> = [];
            console.log("harcMasraflar", this.harcMasraflar);
            this.harcMasraflar.forEach((value) => {
                console.log("value ", value);
                if (value.tur == "D") {
                    // Pul satiri harcMasrafList'e degil postaMasraflariList'e gider.
                    // Alanlar UYAP portaliyle ayni tipte olmali (hepsi string, tutar "0.00" formatinda).
                    postaMasraflariList.push(
                        {
                            silId: postaMasraflariList.length + 1,
                            id: String(value.id),
                            tur: "D",
                            adi: value.adi,
                            adet: String(value.adet),
                            tutar: parseFloat(value.tutar).toFixed(2),
                            aciklama: value.tahsilatAciklama ? value.tahsilatAciklama : "-"
                        }
                    );
                    return;
                }
                if (this.dosya.birimTuru3 != "1199") {
                    // 1199 = icra dairesi. Diger birim turleri icin UYAP'in bekledigi
                    // harcMasrafList formati dogrulanmadi; yanlis format gondermektense
                    // kullaniciyi UYAP'a yonlendiriyoruz.
                    throw new Error("Bu birim türünde harç/masraf ödemesi desteklenmiyor. Lütfen bu dosya için ödemeyi UYAP üzerinden yapınız.");
                }
                // Alan sirasi UYAP'in dosya_odeme_islemleri_brd.ajx istegiyle dogrulandi:
                // tur**id**adet**tutar**adi**aciklama**pesinHarcDusulsunMu**pesinHarcTutari**
                // tarafAdSoyad**kisiKurumId**tarafRolId**tahsilatHarcOrani**otomatikIliskilendirme**tahsilatKayitId
                harcMasrafSatirlari.push([
                    value["tur"],
                    value["id"],
                    value["adet"],
                    value["odenecekTutar"],
                    value["adi"],
                    value["tahsilatAciklama"],
                    value["pesinHarcDusulsunMu"],
                    value["pesinHarcTutari"],
                    value["tarafBilgileri"]["adSoyad"],
                    value["tarafBilgileri"]["kisiKurumId"],
                    value["tarafBilgileri"]["rolId"],
                    value["tahsilatHarcOrani"],
                    value["otomatikIliskilendirme"],
                    value["tahsilatKayitId"]
                ].join("**"));
            })
            return Promise.resolve({
                // Birden fazla harc satiri "|" ile birlestirilir
                harcMasrafList: harcMasrafSatirlari.join("|"),
                postaMasraflariList: postaMasraflariList
            });
        } catch (err) {
            //console.log("createRequestObject");
            console.log(err);
            return Promise.reject(err);
        }
    }

}